/**
 * Rewrite a datetime string to the ECMAScript date-time format, the only one
 * every engine parses the same way: a `T` separator and a `Z` or `±HH:MM`
 * offset. Shared by the frontend's `coerceToUtcDate` and the backend's
 * `parseDbTimestamp`, so the date picker and the SQL builders read a filter
 * value as the same instant.
 *
 * - A zone-less datetime (`"2026-06-21T07:00:00.000"`, `"2026-06-21 07:00:00"`:
 *   a Postgres `timestamp` column, recorded in UTC) gets a `Z`. `new Date()`
 *   would read it in the process's local zone: a GMT+3 viewer saw a
 *   just-created row as "about 3 hours ago", and a GMT+3 server read
 *   audit-log timestamps 3 hours early (KIR-3415).
 * - A zoned datetime keeps its offset, written as `±HH:MM`. Postgres's text
 *   form (`"2026-01-15 14:30:00+00"`) has a space and a short offset that only
 *   V8's legacy parser reads (Safari and Firefox reject it), and
 *   `"2026-01-15T14:30:00-05"` parses nowhere.
 * - Anything else is returned as is: a date-only `"2026-06-21"` (read as UTC
 *   midnight by the spec), an epoch string, or no `date + time` shape at all.
 *
 * Expects a trimmed value (V8 reads a padded date-only string as local
 * midnight).
 */
const DATE_TIME_SHAPE = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)(?:[zZ]|([+-]\d{2})(?::?(\d{2}))?)?$/;
export function toIsoDateTime(value) {
    const match = DATE_TIME_SHAPE.exec(value);
    if (!match)
        return value;
    const [, date, time, offsetHours, offsetMinutes = '00'] = match;
    const zone = offsetHours ? `${offsetHours}:${offsetMinutes}` : 'Z';
    return `${date}T${time}${zone}`;
}
//# sourceMappingURL=date-time.js.map